import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { motion } from 'framer-motion';

const Keuangan = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('potongan');

  const dataKaryawanStr = localStorage.getItem('data_karyawan');
  const dataKaryawan = dataKaryawanStr ? JSON.parse(dataKaryawanStr) : null;
  const isKoordinator = dataKaryawan?.level?.toLowerCase() === 'koordinator';

  // Baca menu_setting dari localStorage
  const menuSettingStr = localStorage.getItem('menu_setting');
  const menuSetting = menuSettingStr ? JSON.parse(menuSettingStr) : null;
  const isPotonganActive = menuSetting ? menuSetting.active !== false : true;

  const tabs = [
    {
      key: 'potongan',
      label: 'Potongan',
      emoji: '💰',
      title: 'Pengajuan Kasbon dan Cicilan',
      desc: 'Fitur pengajuan dan riwayat potongan akan segera hadir.',
    },
    {
      key: 'pendapatan',
      label: 'Pendapatan',
      emoji: '📅',
      title: 'Pengajuan Lembur dan Piket',
      desc: 'Coming soon — kamu bisa mengajukan pendapatan, cuti, atau melihat riwayat di sini.',
    }

  ];

  const currentTab = tabs.find((t) => t.key === activeTab);

  const cardStyle = {
    backgroundColor: '#fff',
    borderRadius: 24,
    padding: '24px 20px',
    width: '100%',
    maxWidth: 450,
    alignSelf: 'center',
    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.05)',
    border: '1px solid #cbd5e1',
    textAlign: 'center',
    boxSizing: 'border-box',
    margin: '0 auto 24px',
  };

  return (
    <div
      style={{
        // position: 'fixed',
        inset: 0,
        background: 'linear-gradient(180deg, #F5F9FF 0%, #E8F1FF 40%, #FFFFFF 100%)',
        display: 'flex',
        flexDirection: 'column',
        fontFamily: 'Poppins, sans-serif',
        overflow: 'hidden',
      }}
    >
      {/* Header Fixed */}
      <div style={{ position: 'relative', height: 80, flexShrink: 0, maxWidth: 450, width: '100%', margin: '0 auto', boxSizing: 'border-box' }}>
        {/* Tombol Back */}
        <motion.button
          onClick={() => navigate('/')}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          whileTap={{ scale: 0.9 }}
          style={{
            position: 'absolute',
            top: 20,
            left: 20,
            width: 40,
            height: 40,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#fff',
            borderRadius: '50%',
            boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
            cursor: 'pointer',
            border: 'none',
            zIndex: 10,
          }}
          aria-label="Kembali"
        >
          <ArrowLeft size={22} color="#333" />
        </motion.button>

        {/* Tab Switcher */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          style={{
            position: 'absolute',
            top: 20,
            right: 20,
            backgroundColor: '#fff',
            borderRadius: 30,
            boxShadow: '0 4px 15px rgba(0, 0, 0, 0.05)',
            border: '1px solid #cbd5e1',
            display: 'flex',
            overflow: 'hidden',
            zIndex: 20,
          }}
        >
          {tabs.map((tab, idx) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              style={{
                padding: '10px 15px',
                fontSize: 17,
                height: 39,
                fontWeight: 600,
                color: activeTab === tab.key ? '#2563eb' : '#666',
                backgroundColor: activeTab === tab.key ? '#eff6ff' : 'transparent',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                border: 'none',
                borderRight: idx < tabs.length - 1 ? '1px solid #cbd5e1' : 'none',
              }}
              aria-selected={activeTab === tab.key}
            >
              {tab.label}
            </button>
          ))}
        </motion.div>
      </div>

      {/* Scrollable Content */}
      <div
        style={{
          flex: 1,
          overflowY: 'auto',
          padding: '20px',
          display: 'flex',
          marginTop: -10,
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <motion.div
          key={activeTab}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          style={cardStyle}
        >
          {activeTab === 'potongan' ? (
            <div style={{ textAlign: 'center' }}>
              {isPotonganActive ? (
                /* === MENU AKTIF: Tampilkan form potongan seperti biasa === */
                <>
                  <div style={{ fontSize: 60, marginBottom: 24 }}>{currentTab?.emoji}</div>
                  <h3 style={{ fontWeight: 700, fontSize: 20, color: '#111827', marginBottom: 16 }}>
                    Pengajuan Potongan
                  </h3>
                  <p style={{ color: '#666', fontSize: 15, lineHeight: '1.6', marginBottom: 24 }}>
                    Pilih form untuk mengajukan kasbon atau cicilan kamu di bawah ini.
                  </p>

                  <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                    {[
                      { key: 'kasbon', title: 'Kasbon', desc: 'Pengajuan kasbon tunai/transfer', icon: '💸' },
                      { key: 'cicilan', title: 'Cicilan', desc: 'Pengajuan cicilan barang/jasa otomatis potong gaji', icon: '📑' },
                    ].map((item, index) => (
                      <div
                        key={index}
                        onClick={() => navigate('/keuangan/form', { state: { jenis: item.key } })}
                        style={{
                          padding: '12px 16px',
                          borderRadius: 16,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          gap: 12,
                          cursor: 'pointer',
                          background: '#ffffff',
                          border: '1px solid #e3eef7',
                          boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                          transition: 'all .25s ease',
                          textAlign: 'left',
                        }}
                        onMouseDown={e => { e.currentTarget.style.background = '#f0f7ff'; e.currentTarget.style.boxShadow = '0 4px 10px rgba(0,123,209,.18)'; }}
                        onMouseUp={e => { e.currentTarget.style.background = '#ffffff'; e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.05)'; }}
                        onMouseLeave={e => { e.currentTarget.style.background = '#ffffff'; e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.05)'; }}
                      >
                        <div style={{ width: 36, height: 36, borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fef3c7', fontSize: 16, flexShrink: 0 }}>
                          {item.icon}
                        </div>
                        <div style={{ flex: 1, textAlign: 'left' }}>
                          <span style={{ fontSize: 14, fontWeight: 700, color: '#222' }}>{item.title}</span>
                          <br />
                          <span style={{ fontSize: 12, color: '#64748b' }}>{item.desc}</span>
                        </div>
                        <div style={{ width: 36, height: 36, borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fef3c7', fontSize: 14, flexShrink: 0 }}>
                          ↗
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                /* === MENU NONAKTIF: Tampilkan halaman maintenance === */
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
                  {menuSetting?.image && (
                    <img
                      src={menuSetting.image}
                      alt="Maintenance"
                      style={{
                        width: '100%',
                        maxWidth: 280,
                        borderRadius: 16,
                        objectFit: 'contain',
                        marginBottom: 8,
                      }}
                    />
                  )}
                  <div style={{
                    background: '#fff8e1',
                    border: '1px solid #ffe082',
                    borderRadius: 14,
                    padding: '14px 18px',
                    width: '100%',
                  }}>
                    <div style={{ fontSize: 20, marginBottom: 6 }}>🚧</div>
                    <p style={{
                      margin: 0,
                      fontSize: 14,
                      fontWeight: 600,
                      color: '#b45309',
                      lineHeight: '1.6',
                    }}>
                      {menuSetting?.reason || 'Menu ini sementara tidak tersedia.'}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 60, marginBottom: 24 }}>{currentTab?.emoji}</div>
              <h3 style={{ fontWeight: 700, fontSize: 20, color: '#111827', marginBottom: 16 }}>
                Pengajuan Pendapatan
              </h3>
              <p style={{ color: '#666', fontSize: 15, lineHeight: '1.6', marginBottom: 24 }}>
                Pilih form untuk mengajukan lembur atau piket kamu di bawah ini.
              </p>

              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {isKoordinator ? [
                  { key: 'lembur', title: 'Lembur', desc: 'Pengajuan jam lembur di luar shift', icon: '⏰' },
                  { key: 'piket_harian', title: 'Piket Harian', desc: 'Lapor piket shift harian', icon: '🏢' },
                  { key: 'perconnote', title: 'Piket Perconnote', desc: 'Ajukan piket berdasarkan jumlah resi', icon: '📦' },
                ].map((item, index) => (
                  <div
                    key={index}
                    onClick={() => navigate('/keuangan/form', { state: { jenis: item.key } })}
                    style={{
                      padding: '12px 16px',
                      borderRadius: 16,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: 12,
                      cursor: 'pointer',
                      background: '#ffffff',
                      border: '1px solid #e3eef7',
                      boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                      transition: 'all .25s ease',
                      textAlign: 'left',
                    }}
                    onMouseDown={e => { e.currentTarget.style.background = '#f0f7ff'; e.currentTarget.style.boxShadow = '0 4px 10px rgba(0,123,209,.18)'; }}
                    onMouseUp={e => { e.currentTarget.style.background = '#ffffff'; e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.05)'; }}
                    onMouseLeave={e => { e.currentTarget.style.background = '#ffffff'; e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.05)'; }}
                  >
                    <div style={{ width: 36, height: 36, borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#e0e7ff', fontSize: 16, flexShrink: 0 }}>
                      {item.icon}
                    </div>
                    <div style={{ flex: 1, textAlign: 'left' }}>
                      <span style={{ fontSize: 14, fontWeight: 700, color: '#222' }}>{item.title}</span>
                      <br />
                      <span style={{ fontSize: 12, color: '#64748b' }}>{item.desc}</span>
                    </div>
                    <div style={{ width: 36, height: 36, borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#e0e7ff', fontSize: 14, flexShrink: 0 }}>
                      ↗
                    </div>
                  </div>
                )) : (
                  <div style={{ padding: '20px', color: '#64748b', fontSize: 13, fontStyle: 'italic' }}>
                    Menu lembur dan piket hanya ditujukan untuk koordinator.
                  </div>
                )}
              </div>
            </div>
          )}
        </motion.div>
      </div>
    </div>
  );
};

export default Keuangan;